<template>
  <iframe
    class="content"
    ref="content"
    :contenteditable="enabled"
  >
  </iframe>
</template>

<script>
export default {
  name: 'BaseEditor',

  components: {
  },

  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    value: String
  },

  data () {
    return {
      observer: null,
      htmlHeader: '<html><head><link rel="stylesheet" href="/static/editor.css"></head><body>',
      htmlFooter: '</body></html>'
    }
  },

  computed: {
  },

  methods: {
    onClick (event) {
      this.$emit('click', event)
    },
    onKeyDown (event) {
      this.$emit('keydown', event)
    },
    onKeyUp (event) {
      this.$emit('keyup', event)
    },
    execCommand () {
      this.getContentDocument().execCommand(...arguments)
    },
    insertContent (html) {
      this.getContentDocument().execCommand('insertHTML', false, html)
    },
    getContentDocument () {
      return this.$refs.content.contentDocument
    },
    getContentWindow () {
      return this.$refs.content.contentWindow
    },
    removeFocus () {
      this.getContentDocument().getSelection().removeAllRanges()
    }
  },

  mounted () {
    var frameDoc = this.getContentDocument()
    frameDoc.open()
    frameDoc.writeln(`${this.htmlHeader}${this.value}${this.htmlFooter}`)
    frameDoc.close()
 
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        this.$emit('input', frameDoc.body.innerHTML)
      })
    })
    const config = { attributes: true, childList: true, characterData: true, subtree: true }
    this.observer.observe(frameDoc, config)

    this.getContentDocument().addEventListener('click', this.onClick)
    this.getContentDocument().addEventListener('keydown', this.onKeyDown)
    this.getContentDocument().addEventListener('keyup', this.onKeyUp)
  },

  beforeDestroy () {
    this.observer.disconnect()
    this.getContentDocument().removeEventListener('click', this.onClick)
    this.getContentDocument().removeEventListener('keydown', this.onKeyDown)
    this.getContentDocument().removeEventListener('keyup', this.onKeyUp)
  }
}

</script>

<style lang="sass" scoped>
iframe
  width: calc(100% - 4px)
  height: 100%
  overflow-y: auto
</style>



// WEBPACK FOOTER //
// BaseEditor.vue?2bc259a0